import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import API_BASE_URL from 'Components/API'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from 'jalali-moment';
import { Box, Autocomplete, TextField, Popper, InputAdornment } from "@mui/material";
import { ReactComponent as SearchIcon } from "Assets/icons/searchLong.svg";
import { useNavigate } from "react-router-dom";
const CustomPopper = function (props) {
    return (
        <Popper
            {...props}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        offset: [5, 15],
                    },
                },
            ]}
        />
    );
};
const RankingOfListingConsultants = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    const [listingData, setListingData] = useState([]);
    const [searchFilters, setSearchFilters] = useState({
        Year: [],
        AdmissionConselorId: [],
    });
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedCounselor, setSelectedCounselor] = useState(null);
    const yearsArr = [];
    const currentYear = moment().locale('fa').format('YYYY');
    const range = 80;
    for (let i = currentYear - 1; i >= currentYear - range; i--) {
        if (i > 1380) {
            yearsArr.push(i);
        }
    }
    
    const content = {
        fa: {
            description: (
                <>
                    برای بررسی <strong className="fw-bold">سوابق مشاوران پذیرش</strong> از طریق لینک زیر اقدام کنید:
                </>
            ),
        },

        en: {
            description: (
                <>
                    To review the <strong className="fw-bold">records of admission consultants</strong>, please use the lists below:
                </>
            ),
        },

        ar: {
            description: (
                <>
                    لمراجعة <strong className="fw-bold">سجلات مستشاري القبول</strong>، يرجى استخدام القوائم أدناه:
                </>
            ),
        },
    };

    const { description } = content[currentLang] || content.fa;
    const fetchListingData = async () => {
        const response = await fetch(`${API_BASE_URL}/Gnr/GetAdmissionsConselors?pageSize=1000000`);
        const jsonData = await response.json();
        setListingData(jsonData.results);
    };
    useEffect(() => {
        fetchListingData();
    }, []);
    // Auto-navigate when both year and counselor are selected
    useEffect(() => {
        if (selectedYear && selectedCounselor) {
            const params = new URLSearchParams();

            // Add Year
            params.append('Years', selectedYear);

            // Add Admission Counselor
            params.append('AdmissionConselorIds', selectedCounselor.id);

            // Navigate to the history page with filters
            navigate(`/Listing/RankingOfListingConsultants?${params.toString()}`);
        }
    }, [selectedYear, selectedCounselor, navigate]);

    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
    };

    const handleCounselorChange = (event, newValue) => {
        setSelectedCounselor(newValue);
    };
    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-6 h-100 justify-content-center flex-column align-items-center d-flex border-left">
                    <div className="mb-5">{description}</div>
                    <div className="justify-content-end mt-2 d-flex">
                        <a href="/Listing/RankingOfListingConsultants" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 align-self-end justify-self-end" >
                            {t("viewAcceptanceAdvisorsRanking")}
                            <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                            </span>
                        </a>
                    </div>
                </div>
                <div className="col-6">
                    <div className="justify-content-center mt-2 d-flex flex-column text-center">
                        <div className="mb-5"></div>
                        <div className="d-flex align-items-center justify-content-center gap-4">
                            <div>
                                <div className="d-flex w-100 justify-content-center gap-3 align-items-center mb-3">
                                    <span className="RankingNumber">1</span>
                                    <div className="card-box-10 card-box-sm w-300">
                                        <Autocomplete
                                            disablePortal
                                            value={selectedYear}
                                            id="yearID"
                                            name="yearID"
                                            options={yearsArr}
                                            getOptionLabel={(option) => option.toString()}
                                            onChange={handleYearChange}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => e.stopPropagation()}
                                            size="small"
                                            popupIcon={null}
                                            clearIcon={null}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder={t('selectYear')}
                                                    variant="outlined"
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            paddingRight: "6px !important",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                                                <ExpandMoreIcon
                                                                    onClick={() => {
                                                                        params.InputProps.ref.current?.parentElement
                                                                            ?.querySelector("input")
                                                                            ?.focus();
                                                                    }}
                                                                    sx={{ color: "#045ba7" }}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            PopperComponent={CustomPopper}
                                            slotProps={{
                                                popper: {
                                                    sx: {
                                                        "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            color: "#000",
                                                            fontSize: "14px",
                                                            minWidth: "350px",
                                                            maxWidth: "600px",
                                                            whiteSpace: "normal",
                                                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                            borderRadius: "8px",
                                                            textAlign: "center",
                                                        },
                                                        "& .MuiAutocomplete-listbox": {
                                                            padding: 0,
                                                            "& .MuiAutocomplete-option": {
                                                                padding: "8px 16px",
                                                                "&[aria-selected='true']": {
                                                                    backgroundColor: "#045BA7",
                                                                    color: "#fff",
                                                                },
                                                                "&:hover": {
                                                                    backgroundColor: "#045BA7",
                                                                    color: "#fff",
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex w-100 justify-content-center gap-3 align-items-center mb-3">
                                    <span className="RankingNumber">2</span>
                                    <div className="card-box-10 card-box-sm w-300">
                                        <Autocomplete
                                            disablePortal
                                            value={selectedCounselor}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => e.stopPropagation()}
                                            id="commodityId"
                                            onChange={handleCounselorChange}
                                            options={listingData}
                                            getOptionLabel={(option) => option.name}
                                            size="small"
                                            popupIcon={null}
                                            clearIcon={null}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder={t('selectAcceptanceAdvisor')}
                                                    variant="outlined"
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            paddingRight: "6px !important",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                                                <ExpandMoreIcon
                                                                    onClick={() => {
                                                                        params.InputProps.ref.current?.parentElement
                                                                            ?.querySelector("input")
                                                                            ?.focus();
                                                                    }}
                                                                    sx={{ color: "#045ba7" }}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            PopperComponent={CustomPopper}
                                            slotProps={{
                                                popper: {
                                                    sx: {
                                                        "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            color: "#000",
                                                            fontSize: "14px",
                                                            minWidth: "350px",
                                                            maxWidth: "600px",
                                                            whiteSpace: "normal",
                                                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                            borderRadius: "8px",
                                                            textAlign: "center",
                                                        },
                                                        "& .MuiAutocomplete-listbox": {
                                                            padding: 0,
                                                            "& .MuiAutocomplete-option": {
                                                                padding: "8px 16px",
                                                                "&[aria-selected='true']": {
                                                                    backgroundColor: "#045BA7",
                                                                    color: "#fff",
                                                                },
                                                                "&:hover": {
                                                                    backgroundColor: "#045BA7",
                                                                    color: "#fff",
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RankingOfListingConsultants;
